import { apiClient } from './api';

export const userPrivilegeService = {
  getPrivilegesByUserId: (userId) => {
    return apiClient.get(`/user-privileges/${userId}`);
  },

  savePrivileges: (data) => {
    return apiClient.put('/user-privileges', data);
  },

  addQuickAction: (userId, action) => {
    return apiClient.post(`/user-privileges/${userId}/quick-actions`, action);
  },

  removeQuickAction: (userId, path) => {
    return apiClient.delete(`/user-privileges/${userId}/quick-actions?path=${encodeURIComponent(path)}`);
  },
};
